import { getPublicProfiles } from '@homeservices/api-kit/search/publicprofile';
import { createPublicProfile } from '@/transformations/public-profile';

export default {
  namespaced: true,
  state () {
    return {
      profile: null,
      profiles: [],
      meta: null,
    };
  },
  actions: {
    async fetch ({ dispatch }, serviceProviderOccupationId) {
      await Promise.all([
        await dispatch('fetchProfile', serviceProviderOccupationId),
      ]);
    },
    async fetchProfile ({ commit }, serviceProviderOccupationId) {
      const { data } = await getPublicProfiles({ ids: serviceProviderOccupationId });
      if (data.results[0]) {
        const profile = createPublicProfile(data.results[0]);
        commit('setProfile', profile);
      }
    },
    async fetchProfiles ({ commit }, { serviceProviderOccupationIds, occupationIds }) {
      const { data } = await getPublicProfiles({ service_provider_identifiers: serviceProviderOccupationIds.join(',') });
      const profiles = data.results.map(createPublicProfile);
      const filteredProfiles = profiles.filter(profile =>
        occupationIds.includes(profile.occupation_id));

      commit('setProfiles', filteredProfiles);
    },
  },
  mutations: {
    setProfile (state, profile) {
      state.profile = profile;
    },
    setProfiles (state, profiles) {
      state.profiles = profiles;
    },
    setMeta (state, meta) {
      state.meta = meta;
    },
  },
};
